import { pickBy } from 'lodash';
import { API, METHODS } from '../../constants';
import { constructURL } from '../common';
import { fetchData } from '../common/apiCalling';

export const createDocumentRequest = ({ data }) => {
    let url = `${API.DOCUMENT_REQUEST}`;
    return fetchData({ method: METHODS.POST, url, body: data });
};

export const getAllDocumentRequest = async ({
    offset,
    limit,
    search,
    filter = {},
    role = '',
    id = '',
}) => {
    let url = `${API.DOCUMENT_REQUEST}?offset=${offset}&limit=${limit}`;
    if (role && id) url += `&role=${role}&id=${id}`;

    const filterObject = Object.fromEntries(
        Object.entries(filter).filter(([key, value]) => key && value !== undefined && value !== ''),
    );
    if (Object.keys(filterObject).length > 0)
        url += `&filter=${encodeURIComponent(JSON.stringify(filterObject))}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return await fetchData({ method: METHODS.GET, url });
};

// get specific document detail
export const getDocumentDetailsByID = ({ id }) => {
    const url = `${API.DOCUMENT_REQUEST}/${id}`;
    return fetchData({ method: METHODS.GET, url });
};

export const doFileUploadEntry = async ({ body }) => {
    let url = `${API.DOCUMENT_UPLOAD}`;
    return fetchData({ body, method: METHODS.POST, url });
};

export const getAllDocumentRequestByAccount = async ({
    hiring_client_id,
    account_id,
    offset,
    limit,
    search,
    filter = {},
}) => {
    const sanitizedFilter = pickBy(filter, (value) => value !== undefined && value !== '');
    const queryParams = {
        offset: offset ? offset : '',
        limit: limit ? limit : '',
        search: search ? encodeURIComponent(search) : '',
        account_id: account_id,
        hiring_client_id: hiring_client_id,
        filter:
            Object.keys(sanitizedFilter)?.length > 0
                ? encodeURIComponent(JSON.stringify(sanitizedFilter))
                : undefined,
    };
    const url = constructURL(API.DOCUMENT_REQUEST, queryParams);
    return await fetchData({ method: METHODS.GET, url });
};

export const getFileUploadsByDocumentRequestID = async ({ documentRequestID }) => {
    const url = `${API.DOCUMENT_UPLOAD}?document_request_id=${documentRequestID}`;
    return fetchData({ method: METHODS.GET, url });
};

export const updateDocsRequest = async ({ id, body }) => {
    const url = `${API.DOCUMENT_REQUEST}/${id}`;
    return fetchData({ body, method: METHODS.PUT, url });
};

export const deleteDocsRequest = async ({ id }) => {
    const url = `${API.DOCUMENT_REQUEST}/${id}`;
    return fetchData({ method: METHODS.DELETE, url });
};

// Document Request Required Fields
export const getDocumentRequestFields = async ({ id }) => {
  const url = `${API.DOCUMENT_REQUEST}/${id}/fields`;
  return fetchData({ method: METHODS.GET, url });
};

export const updateDocumentRequestFields = async ({ id, values }) => {
  const url = `${API.DOCUMENT_REQUEST}/${id}/fields`;
  return fetchData({ method: METHODS.PUT, url, body: { values } });
};
